import { render, staticRenderFns } from "./AppFlatPickr.vue?vue&type=template&id=288c126c&scoped=true"
import script from "./AppFlatPickr.vue?vue&type=script&lang=js"
export * from "./AppFlatPickr.vue?vue&type=script&lang=js"
import style0 from "./AppFlatPickr.vue?vue&type=style&index=0&id=288c126c&prod&lang=scss"
import style1 from "./AppFlatPickr.vue?vue&type=style&index=1&id=288c126c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288c126c",
  null
  
)

export default component.exports